import styled from 'styled-components';
import { zIndex, unthemed } from 'tokens';

export const Overlay = styled.div<{ isClosing?: boolean }>`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: ${unthemed.gray['1000']}BB;
	z-index: ${zIndex.panelOverlay};
	display: flex;
	justify-content: flex-end;

	animation: ${({ isClosing }) => (isClosing ? 'fadeOut 0.15s ease-in' : 'fadeIn 0.15s ease-out')};

	@keyframes fadeIn {
		from {
			opacity: 0;
		}
		to {
			opacity: 1;
		}
	}

	@keyframes fadeOut {
		from {
			opacity: 1;
		}
		to {
			opacity: 0;
		}
	}
`;

export const Panel = styled.div<{ isClosing?: boolean }>`
	width: 400px;
	height: 100vh;
	background: ${({ theme }) => `${theme.gray['0']}`};
	border-left: 1px solid ${({ theme }) => theme.gray['200']};
	display: flex;
	flex-direction: column;
	animation: ${({ isClosing }) =>
		isClosing ? 'slideOut 0.15s ease-in' : 'slideIn 0.15s ease-out'};

	@keyframes slideIn {
		from {
			transform: translateX(100%);
		}
		to {
			transform: translateX(0);
		}
	}

	@keyframes slideOut {
		from {
			transform: translateX(0);
		}
		to {
			transform: translateX(100%);
		}
	}
`;

export const Header = styled.div`
	padding: 16px;
	border-bottom: 1px solid ${({ theme }) => theme.gray['200']};
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

export const Title = styled.h2`
	margin: 0;
	font-size: 18px;
	font-weight: 600;
	color: ${({ theme }) => theme.gray['1000']};
`;

export const CloseButton = styled.button`
	background: none;
	border: none;
	padding: 0;
	width: 24px;
	height: 24px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 4px;

	&:hover {
		background: ${({ theme }) => theme.gray['200']};
	}
`;

export const VideoList = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	padding: 20px;
	padding-top: 16px;
	overflow-y: auto;
	gap: 20px;
`;

export const VideoThumbnail = styled.div`
	width: 100%;
	border-radius: 6px 6px 0 0;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	position: relative;
	overflow: hidden;
`;

export const ThumbnailImage = styled.img`
	width: 100%;
	height: 100%;
	object-fit: cover;
	border-radius: 6px 6px 0 0;
	aspect-ratio: 16/9;
`;

export const PlayIconOverlay = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	display: flex;
	align-items: center;
	justify-content: center;
	background: rgba(0, 0, 0, 0.6);
	border-radius: 50%;
	width: 40px;
	height: 40px;
	opacity: 0;
	transition: opacity 0.2s ease;
`;

export const VideoItem = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	border-radius: 8px;
	cursor: pointer;
	background: ${unthemed.gray['1000']};
	border: 1px solid ${({ theme }) => theme.gray['200']};

	&:hover {
		border: 1px solid ${({ theme }) => theme.gray['400']};
	}

	&:hover ${PlayIconOverlay} {
		opacity: 1;
	}
`;

export const VideoInfo = styled.div`
	padding: 12px;
	padding-bottom: 16px;
	flex: 1;
	width: 100%;
	box-sizing: border-box;
`;

export const VideoHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 10px;
	gap: 6px;
`;

export const VideoTitle = styled.div`
	font-size: 14px;
	font-weight: 600;
	color: ${unthemed.gray['100']};
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	flex: 1;
	margin-right: 8px;
`;

export const VideoDuration = styled.div`
	font-size: 12px;
	font-weight: 300;
	color: ${unthemed.gray['100']};
	flex-shrink: 0;
`;

export const ProgressBar = styled.div<{ progress: number }>`
	width: 100%;
	height: 4px;
	background: ${({ progress }) => `
		linear-gradient(
			to right,
			${unthemed.green[200]} 0%,
			${unthemed.green[200]} ${progress}%,
			${unthemed.gray[400]} ${progress}%,
			${unthemed.gray[400]} 100%
		)
	`};
	border-radius: 2px;
`;
